import {
  SHARE_CAPITAL_ORIGIN_OPTIONS,
  type ShareCapitalOrigin,
} from '../constants/business-finances';

const shareCapitalOriginSet = new Set<string>(SHARE_CAPITAL_ORIGIN_OPTIONS);

export function isShareCapitalOrigin(value: string): value is ShareCapitalOrigin {
  return shareCapitalOriginSet.has(value);
}

export function toShareCapitalOrigin(value: string | null | undefined): ShareCapitalOrigin | null {
  if (typeof value !== 'string' || !isShareCapitalOrigin(value)) return null;
  return value;
}

export function toShareCapitalOrigins(
  values: readonly string[] | null | undefined
): ShareCapitalOrigin[] {
  if (!values) return [];
  return values.filter(isShareCapitalOrigin);
}
